var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("modal", {
    staticClass: "panel-dashboard p-0",
    attrs: {
      show: _vm.show,
      showContent: _vm.showContent,
      pageTitle: _vm.panelTitle,
      closeBtn: _vm.closeBtn,
      position: _vm.position,
      size: _vm.size,
    },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("div", { staticClass: "ct-aside-control-item" }, [
              _c("div", { staticClass: "ct-aside-control-header" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "title d-flex justify-content-between align-items-center w-100",
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.panelTitle) +
                        "\n                "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ct-aside-control-body" }, [
                _c("div", { staticClass: "row no-gutters" }, [
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "div",
                      { staticClass: "row no-gutters" },
                      _vm._l(_vm.modules, function (module, idx) {
                        return _c(
                          "div",
                          {
                            key: `module-side-${idx}`,
                            staticClass: "col-6 mb-3",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "card module-side",
                                class: {
                                  "ml-1 mr-2": idx % 2 == 0,
                                  "mr-1 ml-2": idx % 2 == 1,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-header",
                                    class: {
                                      "h-100": !_vm.isCurrentRoute(
                                        module.route
                                      ),
                                    },
                                  },
                                  [
                                    module.route
                                      ? [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: module.route,
                                                  params: {
                                                    appCode:
                                                      _vm.formatRouteAppCode(
                                                        module.code
                                                      ),
                                                  },
                                                },
                                              },
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.closeModal.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "media h-100" },
                                                [
                                                  module.icon
                                                    ? _c("img", {
                                                        attrs: {
                                                          src: module.icon,
                                                          alt: module.name,
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "media-body",
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.labelModule(
                                                              module.name
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      : module.url
                                      ? [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: module.url,
                                                target: "_blank",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "media h-100" },
                                                [
                                                  module.icon
                                                    ? _c("img", {
                                                        attrs: {
                                                          src: module.icon,
                                                          alt: module.name,
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "media-body",
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.labelModule(
                                                              module.name
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _vm.isCurrentRoute(module)
                                  ? _c("div", { staticClass: "card-body" }, [
                                      _c("p", { staticClass: "card-text" }, [
                                        _vm._v(_vm._s(_vm.titleHere)),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }